import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CacheStorageService } from '../../../../../modules/src/lib/core/services/cache-storage.service';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LoggedOutComponent implements OnInit {

  constructor(private readonly cacheStorageService: CacheStorageService) {
  }

  async ngOnInit(): Promise<void> {
    await this.cacheStorageService.clear();
  }

}
